import { BaseActivityEvent } from './BaseActivityEvent'
import { ReactComponent as Icon } from './icons/merge.svg'
import { Actor } from './Actor'
import { ActivityEventPosition, ArticleMergedIntoEvent, ActivityEventTrackMode } from './Types'
import { Link } from 'react-router-dom'
import { stopPropagation } from 'utils'

interface Props extends ActivityEventPosition {
  event: ArticleMergedIntoEvent
}

const ArticleMergedInto = ({ event, ...props }: Props) => {
  const { user, data } = event
  const { base_branch, general_comment } = data

  return (
    <BaseActivityEvent
      {...props}
      trackMode={ActivityEventTrackMode.Merge}
      icon={<Icon />}
      timestamp={event.timestamp}
      message={general_comment}
      content={
        <>
          <Actor displayName={user.display_name || 'Anonymous user'} userId={user?.id} /> merged this linked copy into
          main{' '}
          <Link to={base_branch.url} onClick={stopPropagation}>
            {base_branch.title}
          </Link>
        </>
      }
    />
  )
}

export { ArticleMergedInto }
